export * from './ps-footer.component';
